$(function(){
  
  var obs = 0;
  var header = $('header');
  if($('height-observer').length){
    obs = $('height-observer[variable="announcement-bar"]').outerHeight(true);
  }
  if(header.offset().top > obs){
    header.find('x-header').addClass('is-solid');
  }else if(header.offset().top <= obs){
    header.find('x-header').removeClass('is-solid');
  }
  $(window).on("resize scroll",function(){
    if($('height-observer').length){
      obs = $('height-observer[variable="announcement-bar"]').outerHeight(true);
    }
    if(header.offset().top > obs){
      header.find('x-header').addClass('is-solid');
    }else if(header.offset().top <= obs){
      header.find('x-header').removeClass('is-solid');
    }
  });
  
  
  var uaOs = window.navigator.userAgent.toLowerCase();
  var uaBrowser = window.navigator.userAgent.toLowerCase();
  
  
  //横スクロール
  $.prototype.draggable = function() {
    var t;
    $(this).each(function(i,e) {
      $(e).mousedown(function(e2) {
        e2.preventDefault();
        t = $(e);
        $(e).data({
          down: true,
          x: e2.clientX,
          y: e2.clientY,
          left: $(e).scrollLeft(),
          top: $(e).scrollTop()
        });
      });
    });
    $(document).mousemove(function(e) {
      if($(t).data("down")) {
        e.preventDefault();
        $(t).scrollLeft($(t).data("x")+$(t).data("left")-e.clientX);
        $(t).scrollTop($(t).data("y")+$(t).data("top")-e.clientY);
      }
    }).mouseup(function(e) {
      $(t).data("down", false);
    });
  };

  $('.header__primary-nav-item details .header__dropdown-menu.unstyled-list').each(function(){
    if($(this).find('>li').length > 5){
       $(this).addClass('list_'+$(this).find('>li').length);
    }
  });
  $('.header__primary-nav-item details details').each(function(){
    var nav = $(this).find('ul.header__dropdown-menu').addClass('child').clone();
    $(this).after(nav);
  });
  
  if($('.template_index').length){
    var txt = $('.template_index .section-spacing.online_store_top_category .collection-list.wrap').html();
    $('.template_index .section-spacing.online_store_top_category .collection-list.wrap').html(txt.replaceAll('<a', '<span').replaceAll('/a>', '/span>'));
    $('.template_index .section-spacing.online_store_top_category span').each(function(){
      var link = $(this).attr('href');
      var linkArea = $(this).find('.collection-card__content');
      linkArea.html( '<a href="'+link+'">' + linkArea.html() + '</a>' );
    });
    
    //横スクロール
    $(".template_index .section-spacing.online_store_top_category .section-stack").draggable();
  }
  
  if($('.template_page_index').length){
    var txt = $('.template_page_index .section-spacing.category .collection-list.wrap').html();
    $('.template_page_index .section-spacing.category .collection-list.wrap').html(txt.replaceAll('<a', '<span').replaceAll('/a>', '/span>'));
    $('.template_page_index .section-spacing.category span').each(function(){
      var link = $(this).attr('href');
      var linkArea = $(this).find('.collection-card__content');
      linkArea.html( '<a href="'+link+'">' + linkArea.html() + '</a>' );
    });
    
    //横スクロール
    $(".template_page_index .section-spacing.category .section-stack").draggable();
  }
  if($('body.template_collection').length){
    if($('.prose.noimg').length){
      $('body').addClass('collection_noimg');
    }
     
    if (uaOs.indexOf("windows nt") !== -1 || uaBrowser.indexOf("chrome") != -1) {
      if (uaBrowser.indexOf("chrome") != -1){
        $('body').addClass('chrome');
        // $(window).on("resize load",function(){
        //   var mt = $('header').outerHeight(true);
        //   $('main').css({'margin-top':mt + 'px'});
        // });
      }else
      if (uaBrowser.indexOf("firefox") != -1){
        $('body').addClass('firefox');
        // $(window).on("resize load",function(){
        //   var mt = $('header').outerHeight(true);
        //   $('main').css({'margin-top':mt + 'px'});
        // });
      }
    }else 
    if(uaOs.indexOf("iphone") !== -1) {
      if (uaBrowser.indexOf("edg") != -1 || uaBrowser.indexOf("edge") != -1) {
      } else if (uaBrowser.indexOf("safari") != -1) {
          // iOSはSafariの識別子が必ず入ってしまうので、更に分岐させる必要がある
          if (uaBrowser.indexOf("crios") != -1 || uaBrowser.indexOf("fxios") != -1) {
          } else {
            $('body').addClass('safari');
          }
      }
      
    }
    $(window).on("resize scroll",function(){
      $('.content-over-media').addClass('adjustment');
    });
  }
  
  if($('body.template_blog_feature ').length){
    $(".template_blog_feature .blog-tags").draggable();
  }
  if($('body.template_blog_topics ').length){
    $(".template_blog_topics .blog-tags").draggable();
  }
  
  if($('body.template_product ').length){
    $(".yoko_scroll").draggable();
    
    $(window).on("load",function(){
      if(!$('.shopify-section--related-products product-recommendations').length){
         $('.shopify-section--related-products').addClass('last');
      }
    });
    
  }
  
});